<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return 'Threshold';
                }
            },
            component_id: {
                default(){
                    return 'threshold';
                }
            },
            frameProfile: {
                required: true
            },
            openingDirection: {
                required: true
            },
            cill: {
                default(){
                    return '';
                }
            },
            doorRange: {
                required: true
            },
            securedByDesign: {
                default(){
                    return '1';
                }
            },
        },
        computed: {
            thumbURL() {
              return '/thumb/profile/';
            },
            passed_filter(){
                return this.variable_ready(this.frameProfile, this.openingDirection, this.cill, this.doorRange, this.securedByDesign);
            },
            url(){
                return '/api/options/' + this.fabricator + '/technical-threshold?profile=' + this.frameProfile + '&opening_direction=' + this.openingDirection + '&cill=' + this.cill + '&door_range=' + this.doorRange + '&secured_by_design=' + this.securedByDesign;
            },
            cache_key(){
                return '_' + this.frameProfile + '_' + this.openingDirection + '_' + this.cill + '_' + this.doorRange + '_' + this.securedByDesign;
            }
        },
        watch: {
            cache_key: function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
